import React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import APChipAvatarStyles from './styles/APChipAvatar.style';
import Avatar from '@mui/material/Avatar';

interface APChipAvatarProps extends WithStyles<typeof APChipAvatarStyles> {
  icon?: string,
  label: string,
}

class APChipAvatar extends React.Component<APChipAvatarProps, {}> {

  state = {
    image: '',
    imageURL: ''
  };

  setImageAsset = () => {
    const {
      icon
    } = this.props;

    import(`./assets/${icon}.svg`).then(({ default: image }) => {
      this.setState({
        image,
        imageURL: icon
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  componentDidMount() {
    const {
      icon
    } = this.props;

    if (icon) {
      this.setImageAsset();
    }
  }

  componentDidUpdate(prevProps: Readonly<APChipAvatarProps>, prevState: any, snapshot?: any): void {
    const {
      icon
    } = this.props;
    if (icon && icon !== prevState.imageURL) {
      this.setImageAsset();
    }
  }

  render() {
    const {
      classes,
      label
    } = this.props;

    return (
      <div className={classes.avatarWrapper}>
        {this.state.image && <Avatar alt={label} src={this.state.image} />}
      </div>
    );
  }
}

export default withStyles(APChipAvatarStyles)(APChipAvatar);